function RenderContentBlocks({ blocks }) {
  if (!blocks || !Array.isArray(blocks)) return null;

  return blocks.map((block, i) => {
    // 1. COMPOUND SECTION BLOCK WRAPPER
    if (block.type === "section") {
      return (
        <section
          key={i}
          className="content-section-group"
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            marginTop: "12px",
            paddingBottom: "4px",
            padding: "0",
          }}
        >
          {block.heading && (
            <h3
              style={{
                fontSize: "14px",
                fontWeight: "500",
                color: "#1a2127",
              }}
            >
              {block.heading}
            </h3>
          )}
          {/* Recursively pass down nested layouts like paragraphs or lists inside the section wrapper */}
          <RenderContentBlocks blocks={block.children} />
        </section>
      );
    }

    // 2. STEP SUBHEADINGS
    if (block.type === "subheading") {
      return (
        <h4
          key={i}
          style={{
            fontSize: "14px",
            fontWeight: "500",
            marginTop: "12px",
            color: "#2B3034",
          }}
        >
          {block.text}
        </h4>
      );
    }

    // 3. BULLETED LISTS
    if (block.type === "list") {
      return (
        <ul
          key={i}
          style={{
            margin: "4px 0 8px 0",
            display: "flex",
            flexDirection: "column",
            gap: "6px",
          }}
        >
          {block.items.map((item, idx) => (
            <li
              key={idx}
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "flex-start",
                gap: "5px",
              }}
            >
              <img
                src={`${process.env.PUBLIC_URL}/images/icons/check_grey.svg`}
                alt="Check"
                style={{
                  width: "14px",
                  height: "14px",
                  marginTop: "2px",
                  flexShrink: 0,
                }}
              />
              <span
                style={{
                  color: "#40464B",
                  fontSize: "14px",
                  fontWeight: "300",
                }}
              >
                {item}
              </span>
            </li>
          ))}
        </ul>
      );
    }

    // 4. BASE PARAGRAPHS
    return (
      <p
        key={i}
        style={{
          color: "#33393f",
          margin: 0,
          fontSize: "14px",
          fontStyle: "normal",
          lineHeight: "120%",
          fontWeight: "300",
        }}
      >
        {block.text}
      </p>
    );
  });
}

export default RenderContentBlocks;
